<shared-ui-modal-base-modal
  [title]="'modal-mobile-phone-verification-title' | translate"
  [retryButtonTitle]="'button-resend-code' | translate"
  [hasXButton]="false"
  [hasIcon]="true"
  [closeOnConfirm]="false"
  [confirmButtonTitle]="'button-register' | translate"
  [confirmButtonDisabled]="!formGroup.valid"
  [cancelButtonType]="buttonType.Primary"
  [hasRetryButton]="true"
  [disableAllButtons]="disableButtons"
  (confirmOutput)="completeRegistration()"
  (retryOutput)="resendCode()"
>
  <p class="text-center fw-bold mb-3">
    <b>
      {{ 'modal-mobile-phone-verification-body-one' | translate }}
      <b>{{ phoneNumber }}</b>
      <br />
      {{ 'modal-mobile-phone-verification-body-two' | translate }}
    </b>
  </p>
  <div class="form-group mb-3">
    <label class="text-center fw-bold w-100" for="verification_code">{{ 'input-verification-code' | translate }}</label>
    <shared-ui-inputs-input-group
      [id]="'verification_code'"
      [parentFormGroup]="formGroup"
      [formName]="'code'"
      [name]="'input-verification-code' | translate"
      [placeholder]="'input-verification-code' | translate"
      [showLabel]="false"
    ></shared-ui-inputs-input-group>
  </div>
</shared-ui-modal-base-modal>
